<template>
  <div class="p-the-template-h">
    <div class="p-the-template-h__header">
      <CommonHeading>{{ heading }}</CommonHeading>
    </div>
    <div class="p-the-template-h__body">
      <div class="p-the-template-h__body__inner">
        <div v-if="$slots['title']" class="p-the-template-h__body__header">
          <h2 class="p-the-template-h__body__heading">
            <slot name="title" />
          </h2>
          <div
            v-if="$slots['header-label']"
            class="p-the-template-h__body__header__label"
          >
            <slot name="header-label" />
          </div>
        </div>
        <div class="p-the-template-h__body__content">
          <slot name="contents" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    heading: { type: String, required: true }
  },
  components: {
    CommonHeading
  }
})
export default class TheTemplateH extends Vue {
  heading!: string;
}
</script>

<style lang="scss" scoped>
.p-the-template-h {
  @include pc {
    max-width: rem(1110);
    margin: 0 auto;
    padding: rem(32) 0 rem(48);
  }

  &__header {
  }

  &__body {
    @include pc {
      margin-top: rem(16);
      padding: rem(48) 0;
    }
    @include sp {
      padding: rem(24) 0 rem(48);
    }
    background-color: $common-white;
    border-radius: rem(4);

    &__inner {
      @include pc {
        width: cal(966, 1110);
        margin: 0 auto;
      }
    }

    &__header {
      @include pc {
        padding-bottom: rem(32);
      }
      @include sp {
        padding-bottom: rem(12);
      }
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      border-bottom: px(1) solid $common-gray-border;

      &__label {
        @include pc {
          font-size: rem(12);
        }
        display: flex;
        justify-content: flex-end;
        color: $common-black-sub;
        width: rem(120);
        min-width: rem(120);
      }
    }

    &__heading {
      @include pc {
        font-size: rem(24);
      }
      @include sp {
        font-size: rem(16);
      }
      font-weight: bold;
      flex-grow: 1;
    }

    &__header + &__content {
      @include pc {
        margin-top: rem(32);
      }
      @include sp {
        margin-top: rem(24);
      }
    }
  }
}
</style>
